import { useState, useCallback } from 'react';

function useVisible(defaultVisible = false) {
  const [visible, setVisible] = useState(defaultVisible);

  const onOpen = useCallback(() => {
    setVisible(true);
  }, []);

  const onClose = useCallback(() => {
    setVisible(false);
  }, []);

  return { visible, onOpen, onClose };
}

export default useVisible;
